import { LocaleLink } from "@/components/LocaleLink";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/seo/SEOHead";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center section-padding">
      <SEOHead title={t("notFound.title")} noindex />
      <div className="text-center space-y-8">
        <span className="text-micro">404</span>
        <h1 className="text-headline">{t("notFound.title")}</h1>
        <p className="text-caption">{t("notFound.description")}</p>
        <LocaleLink to="/">
          <Button variant="quiet">{t("common.backToHome")}</Button>
        </LocaleLink>
      </div>
    </div>
  );
};

export default NotFound;
